import TableStructure from 'common/TableStructure';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import React from 'react';

const GridContainer = styled.div`
    width: 100%;
    overflow-x: auto;
    
    @media (min-width: 768px) {
        overflow-x: visible;
    }
`;

export default function LocationTable({ rows, togglePopup }) {

    const columns = [
        {
            field: 'id',
            headerName: <FormattedMessage id="be.seen.invoice.table.date" defaultMessage="ID" />,
            flex: 0.3,
            minWidth: 60,
        },
        {
            field: 'nickName',
            headerName: <FormattedMessage id="be.seen.invoice.table.nick.name" defaultMessage="Nick Name" />,
            flex: 1,
            minWidth: 120,
        },
        {
            field: 'phoneNumber',
            headerName: <FormattedMessage id="be.seen.invoice.table.phone.number" defaultMessage="Phone Number" />,
            flex: 0.7,
            minWidth: 100,
        },
        {
            field: 'address',
            headerName: <FormattedMessage id="be.seen.invoice.table.address" defaultMessage="ADDRESS" />,
            flex: 1.2,
            minWidth: 150,
        },
        {
            field: 'city',
            headerName: <FormattedMessage id="be.seen.invoice.table.city" defaultMessage="CITY" />,
            flex: 0.6,
            minWidth: 80,
        },
        {
            field: 'state',
            headerName: <FormattedMessage id="be.seen.invoice.table.state" defaultMessage="STATE" />,
            flex: 0.4,
            minWidth: 60,
        },
        {
            field: 'zip',
            headerName: <FormattedMessage id="be.seen.invoice.table.zip" defaultMessage="ZIP" />,
            flex: 0.4,
            minWidth: 60,
        },
        {
            field: '',
            headerName: '',
            sortable: false,
            flex: 0.3,
            minWidth: 50,
            renderCell: (params) => {
                return (
                    <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                            cursor: 'pointer',
                            marginLeft: 'auto',
                            marginRight: '12px',
                        }}
                    >
                        <path
                            d="M9 18L15 12L9 6"
                            stroke="#666666"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                );
            },
        },
    ];
    return (
        <GridContainer>
            <TableStructure rows={rows} columns={columns} handleRowClick={togglePopup}></TableStructure>
        </GridContainer>
    );
}
